import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

class VeyreInstallments extends HTMLElement {
  connectedCallback() {
    this.productForm = this.closest('[data-ref="product-section-content"]')?.querySelector('[data-ref="product-form"]');
    this.productForm?.addEventListener(ThemeEvents.formUpdated, this.updateEstimate);
  }
  disconnectedCallback() {
    this.productForm?.removeEventListener(ThemeEvents.formUpdated, this.updateEstimate);
  }
  updateEstimate = (event) => {
    const price = event.detail?.prices?.price;
    if (!Number.isFinite(price) || price < 0) return;
    const first = Math.round(price / 3);
    const last = price - first * 2;
    this.querySelector('[data-installment]').textContent = formatMoney(first);
    this.querySelector('[data-installment-schedule]').textContent = `${formatMoney(first)} + ${formatMoney(first)} + ${formatMoney(last)}`;
  };
}

class VeyreSliderToggle extends HTMLElement {
  async connectedCallback() {
    this.button = this.querySelector('button');
    await customElements.whenDefined('slider-component');
    if (!this.isConnected) return;
    this.component = this.closest('.shopify-section')?.querySelector('slider-component[data-autoplay="true"]');
    this.autoplay = this.component?.slider?.Components?.Autoplay;
    if (!this.autoplay) return;
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.motion.matches;
    this.button.hidden = false;
    this.button.addEventListener('click', this.toggle);
    this.motion.addEventListener('change', this.motionChanged);
    this.render();
  }
  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
    this.motion?.removeEventListener('change', this.motionChanged);
  }
  toggle = () => {
    this.paused = !this.paused;
    this.paused ? this.autoplay.pause() : this.autoplay.play();
    this.render();
  };
  motionChanged = () => {
    if (this.motion.matches) {
      this.paused = true;
      this.autoplay.pause();
      this.render();
    }
  };
  render() {
    const label = this.paused ? this.dataset.play : this.dataset.pause;
    this.button.setAttribute('aria-label', label);
    this.button.setAttribute('aria-pressed', String(this.paused));
    this.querySelector('[data-motion-icon]').textContent = this.paused ? '▶' : 'Ⅱ';
    this.querySelector('[data-motion-label]').textContent = label;
  }
}

if (!customElements.get('veyre-installments')) customElements.define('veyre-installments', VeyreInstallments);
if (!customElements.get('veyre-slider-toggle')) customElements.define('veyre-slider-toggle', VeyreSliderToggle);
